import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogCloseEvent, PageKey, Role } from '../../const';
import { Users } from '../../models/user-center.model';
import { PageEvent } from '@angular/material/paginator';
import { AccountAdminCenterService } from './account-admin-center.service';
import { CreateAccountAdminComponent } from './create-account-admin/create-account-admin.component';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';
import { DtoSector } from '../../models/sector.model';
import { SectorService } from '../sector/sector.service';
import { SearchService } from '../common/search.service';

export enum Tabs { ActiveUserCenter = "ActiveUserCentre", DeletedUserCenter = "DeletedUserCentre" }

@Component({
  selector: 'app-account-admin-center',
  templateUrl: './account-admin-center.component.html'
})
export class AccountAdminCenterComponent implements OnInit {
  userDetails: any = [];
  isEditUser: boolean = false;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  searchTerm: string = "";
  pageKey = PageKey.AccountAdminCenter;
  sortFirstNameAsc: boolean = true;
  sortLastNameAsc: boolean = true;
  sortEmailIdAsc: boolean = true;
  sortCountryCodeAsc: boolean = true;
  activeTab: string = Tabs.ActiveUserCenter;
  tabs = Tabs;
  userRole: string[] = [];
  roles = Role;
  sortColumn: string = "";
  sortDirection: string = "";
  sectors: DtoSector[] = [];

  constructor(private accountAdminCenterService: AccountAdminCenterService,
    private toasterService: ToastrService, private readonly searchService: SearchService,
    private dialog: MatDialog, private sectorService: SectorService
  ) { }

  ngOnInit(): void {
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
    this.getUserData();
    this.getSectors();
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
  }

  getSectors() {
    this.sectorService.getSectors().subscribe((response: DtoSector[] | any) => {
      this.sectors = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  ngAfterViewInit() {
    this.applyTruncateClass();
  }

  applyTruncateClass() {
    const element = this.userDetails.nativeElement;
    if (element && element.scrollWidth > 200) {
      element.classList.add('truncate');
    }
  }
  setTabName(tabName: string) {
    this.activeTab = tabName;
    this.searchTerm = "";
    this.pageSize = 10;
    this.pageNumber = 0;
    this.pageOffSet = 0;
    this.sortColumn = "";
    this.sortDirection = "";
  }

  getUserData(sortColumn = "", sortDirection = "") {
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
      payload.isActiveAccountList = this.activeTab == this.tabs.ActiveUserCenter;
      payload.getAllAccountAdmin = true;
    this.isEditUser = false;
    this.accountAdminCenterService.getUserDetails(payload).subscribe((response: any) => {
      this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      this.userDetails = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getUserData();
  }

  openCreateAccountAdminDialog(userDetail: any = {}) {
    userDetail.sectors = this.sectors;
    this.dialog.open(CreateAccountAdminComponent, {
      width: '800px',
      data: userDetail || {}
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.getUserData();
      }
    });
  }

  openDeleteOrRecoverAccountAdminDialog(userDetail: Users, toDelete: boolean = false) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to " + (toDelete ? " delete" : " recover") + " the account admin?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.accountAdminCenterService.deleteOrRecoverUser(userDetail.userId.toString(), toDelete).subscribe((response: any) => {
          if (response.isSuccess) {
            this.toasterService.success('User details ' + (toDelete ? " deleted" : " recovered") + ' successfully', 'Success');
            this.getUserData();
          }
        }, (errorResponse: HttpErrorResponse) => {
          if(errorResponse.error){
            this.toasterService.error(errorResponse.error, "Error");
          }
        })
      }
    });
  }

  openDeleteAccountAdmin(userId: number){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the account admin?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        if(userId > 0){
          this.accountAdminCenterService.deleteUser(userId.toString()).subscribe((response: any)=>{
            if (response) {
              this.toasterService.success('User details deleted successfully', 'Success');
              this.getUserData();
            }
          }, (errorResponse: HttpErrorResponse) => {
            if(errorResponse.error){
              this.toasterService.error(errorResponse.error, "Error");
            }
          })
        }
      }
    });
  }
}
